import { computed, defineComponent, ref, watch } from 'vue';
export default defineComponent({
    props: {
        modelValue: [String, Number],
        disabled: Boolean,
        fetchSuggestions: Function,
        labelKey: {
            type: String,
            default: 'value'
        },
        searchCount: {
            type: Number,
            required: true
        }
    },
    emits: ['update:modelValue', 'select'],
    setup(props, { emit }) {
        const value = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });
        const autocompleteRef = ref(null);
        const searchInput = ref({
            old: '',
            now: ''
        });
        const onSelect = (data) => {
            searchInput.value = {
                old: data[props.labelKey],
                now: data[props.labelKey]
            };
            value.value = data.value;
            emit('select', data);
        };
        watch(() => {
            return searchInput.value.now;
        }, (newVal) => {
            if (newVal.length < props.searchCount) {
                value.value = '';
            }
        });
        watch(() => {
            var _a;
            return (_a = autocompleteRef.value) === null || _a === void 0 ? void 0 : _a.suggestionVisible;
        }, () => {
            var _a, _b;
            if (((_a = autocompleteRef.value) === null || _a === void 0 ? void 0 : _a.suggestions) &&
                ((_b = autocompleteRef.value) === null || _b === void 0 ? void 0 : _b.suggestions.length) === 0 &&
                !value.value) {
                searchInput.value.old = '';
            }
        });
        watch(value, (newVal) => {
            if (!newVal) {
                searchInput.value = {
                    old: '',
                    now: ''
                };
            }
        });
        const onInputBlur = () => {
            searchInput.value.now = searchInput.value.old;
        };
        return {
            autocompleteRef,
            value,
            searchInput,
            onSelect,
            onInputBlur
        };
    }
});
